export default __webpack_public_path__ + "static/media/439.60dd24af.gif";